import * as React from 'react';

import {ClassNameBuilder} from '../../utils/ClassNameBuilder';
import {TypographyClassNames} from '../../styles/typography/Typography';

import * as Styles from './LineBreak.module.scss';

interface Props {
    prefix?: React.ReactNode;
    className?: string;
}

export const LineBreak: React.FC<Props> = (props) => {
    const {prefix = '', className = '', children} = props;

    return (
        <div className={ClassNameBuilder.join(Styles, className, 'line-break')}>
            <div className={ClassNameBuilder.join(Styles, 'prefix', TypographyClassNames.Overline)}>{prefix}</div>
            <div className={TypographyClassNames.Overline}>
                {children}
            </div>
        </div>
    );
};
